import { MCPAnimation } from '@/app/_common/mcp-loader'
import { Button } from '@/components/ui/button'
import { useTranslate } from '@tolgee/react'

interface OAuthConnectionFieldProps {
  onClick: () => void
  disabled?: boolean
  loading?: boolean
  bypassVerifyAnimation?: boolean
  error?: boolean
}

export function OAuthConnectionField({
  onClick,
  disabled = false,
  loading = false,
  bypassVerifyAnimation = false,
  error = false,
}: OAuthConnectionFieldProps) {
  const { t } = useTranslate()

  return (
    <Button
      type='button'
      onClick={onClick}
      disabled={disabled}
      title={t('serviceRegistry.dialog.connection.verify')}
      unstyled
    >
      <MCPAnimation loading={loading} bypassVerify={bypassVerifyAnimation} error={error} />
    </Button>
  )
}
